import React from "react"
import styled from "styled-components"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"

const StyledSection = styled.section`
  background-color: #151515;
  padding: 32px 44px;
  .mobile-logos {
    max-width: 100%;
  }
  .pc-logos {
    display: none;
  }
  @media (min-width: 768px) {
    padding: 0 88px;
    position: relative;
  }
  @media (min-width: 1024px) {
    transform: translateY(-203px);
    margin-bottom: -203px;
    margin-left: 8%;
    border-radius: 8px;
    height: 506px;
    .mobile-logos {
      display: none;
    }
    .pc-logos {
      display: block;
      max-width: 100%;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      max-height: 346px;
    }
  }
`
const Logos = () => {
  const { logosMobile, logosPc } = useStaticQuery(graphql`
    query {
      logosMobile: file(relativePath: { eq: "companies/logos-mobile.png" }) {
        childImageSharp {
          fluid(maxWidth: 544) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      logosPc: file(relativePath: { eq: "companies/logos-pc.png" }) {
        childImageSharp {
          fluid(maxWidth: 2140) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return (
    <StyledSection>
      <Img
        fluid={logosMobile.childImageSharp.fluid}
        alt="Firmy z którymi współpracowaliśmy"
        title="Nasi klienci"
        className="mobile-logos"
        objectFit="scale-down"
      />
      <Img
        fluid={logosPc.childImageSharp.fluid}
        alt="Firmy z którymi współpracowaliśmy"
        title="Nasi klienci"
        objectFit="contain"
        className="pc-logos"
      />
    </StyledSection>
  )
}

export default Logos
